<template>
  <div class="saleGoodsDetail">
    <div class="saleGoodsDetails" v-if="saleType==1">
      <div class="part" v-for="(item,i) in list" :key="i">
        <div class="title">
          <span>{{item.supplier_name}}</span>
          批次号：{{item.batch}}
        </div>
        <div class="info">
          <div>
            <div
              v-if="item.goods_bale!=3"
            >{{Number(item.goods_num).toFixed(2)}}{{unit_list[item.goods_num_unit-1].name}}</div>
            <div>{{Number(item.weight).toFixed(2)}}公斤</div>
            <div>销量</div>
          </div>
          <div>
            <div
              v-if="item.goods_bale!=3"
            >{{Number(item.receivables/item.goods_num).toFixed(2)}}元/{{unit_list[item.goods_num_unit-1].name}}</div>
            <div>{{item|numToFixed}}元/公斤</div>
            <div>均价</div>
          </div>
          <div class="part3">
            <div class="money3">{{item.receivables|unitChange}}</div>
            <div class="title3">销售额({{item.receivables|moneyUnit}})</div>
          </div>
        </div>
        <div class="date">创建时间：{{item.create_time|timeToDate}}</div>
      </div>
    </div>
    <div v-if="saleType==2" class="saleBatchGoodsDetails">
      <div class="listBox">
        <div class="list" v-for="(batchItem,batchIndex) in batchList" :key="batchIndex">
          <div>订单编号：{{batchItem.order_sn}}</div>
          <div>
            <div>{{batchItem.buyer_name}}</div>
            <div>¥{{batchItem.goods_total_price}}</div>
          </div>
          <div>
            <div v-if="batchItem.goods_bale!=3">销量：{{Number(batchItem.goods_num).toFixed(2)}}{{unit_list[batchItem.goods_num_unit-1].name}}({{Number(batchItem.goods_weight).toFixed(2)}}公斤)</div>
            <div v-else>销量：{{Number(batchItem.goods_weight).toFixed(2)}}公斤</div>
            <div>单价：{{batchItem.goods_price}}元/公斤</div>
          </div>
          <div>销售时间：{{batchItem.order_create_time | timeToDate}}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { goods_detail,batch_goods_detail } from "@/api/work/manage/sale.js";
import {
  weightUnit,
  weightUnitChange,
  moneyUnit,
  unitChange
} from "@/utils/saleFilter.js";
import {
  timestampToDate,
  timestampToDateNewDate,
  timestampToTime,
  longtimestampToDate
} from "@/utils/timestamp";
export default {
  name: "saleGoodsDetail",
  data() {
    return {
      list: [],
      batchList:[],
      name: "",
      saleType: 0,
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    // ...
    to.meta.title = to.query.name?to.query.name + "的销售明细":'批次销售明细';
    next();
  },
  created() {
    let obj = {};
    
    obj.time_star = this.$route.query.time_star;
    obj.time_end = this.$route.query.time_end;
    obj.name = this.$route.query.name?this.$route.query.name:'';
    obj.batch=this.$route.query.goods_batch?this.$route.query.goods_batch:''
    this.saleType = this.$route.query.saleType;
    if(this.$route.query.saleType==1){
      this.getGoodsDetail(obj);
    }else{
      this.getBatchGoodsDetail(obj)
    }
  },
  mounted() {},
  filters: {
    weightUnit,
    weightUnitChange,
    moneyUnit,
    unitChange,
    numToFixed(obj) {
      if (obj.weight != 0) {
        return (obj.receivables / obj.weight).toFixed(2);
      } else {
        return "-";
      }
    },
    timeToDate(time) {
      let date = new Date(time * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  },
  methods: {
    // 获取数据
    getGoodsDetail(name) {
      goods_detail(name).then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
    //批次详情进来数据
    getBatchGoodsDetail(goods_batch){
      batch_goods_detail(goods_batch).then(res=>{
        console.log('===',res)
        if(res.code==200){
          this.batchList=res.data
        }
      })

    }
  }
};
</script>

<style lang="less" scoped>
.saleGoodsDetails {
  .part {
    width: 6.7rem;
    padding: 0 0.2rem;
    background-color: #fff;
    margin: 0.2rem auto;
    .title {
      line-height: 0.75rem;
      border-bottom: 0.01rem solid #e5e5e5;
      > span {
        font-size: 0.36rem;
        margin-right: 0.33rem;
      }
    }
    .info {
      display: flex;
      border-bottom: 0.01rem solid #e5e5e5;
      padding: 0.2rem 0;
      > div {
        width: 30%;
        box-sizing: border-box;
        text-align: center;
        height: 66px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        > div:first-child {
          font-size: 0.32rem;
          color: #333333;
        }
        .money3 {
          margin-top: 0.2rem;
        }
        .title3 {
          margin-top: 0.3rem !important;
        }
        > div:last-child {
          font-size: 0.28rem;
          color: #999999;
          margin-top: 0.19rem;
        }
      }
      >div:nth-of-type(2){
        width:40%!important ;
      }
    }
    .date {
      line-height: 0.67rem;
    }
  }
  .part:last-child {
    margin-bottom: 0.2rem;
  }
}
.saleBatchGoodsDetails{
  .listBox{
    width: 100%;
    margin-top: 0.2rem;
    .list{
      padding: 0.3rem 0.2rem 0.2rem 0.3rem;
      background: #fff;
      margin-bottom: 0.2rem;
      >div{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      >div:nth-of-type(1){
        color: #31B158;
        font-size: 0.32rem;
        margin-bottom: 0.2rem;
      }
      >div:nth-of-type(2){
        color: #333333;
        font-size: 0.36rem;
        margin-bottom: 0.2rem;
        div:nth-of-type(2){
          font-weight: bold;
        }
      }
      >div:nth-of-type(3){
        color: #999999;
        font-size: 0.28rem;
        margin-bottom: 0.2rem;
      }
       >div:nth-of-type(3){
        color: #999999;
        font-size: 0.28rem;
        margin-bottom: 0.2rem;
      }
    }
  }
}
</style>